import { css, keyframes } from '@emotion/core'
import styled, { Theme, ThemeProps } from '@themes/theme'
import { MatchBtnH } from '@styles/match.style'
import { CommonPeekAni, AniPointColor, AniPointColorHide } from '@views/Matchup/BetSlip/index.style'
import { FloatingBottom2, NavH, SafeAreaConstantPadding, SafeAreaEnvPadding } from '@styles/base.style'

// default tag에 onClick event 사용시 es lint error 처리를 위한 기본 tag 추가
export const SpanButton = styled.span`
  cursor: pointer;
`

// button animation
export const bounce = keyframes`
from, 20%, 53%, 80%, to {
  transform: translate3d(0,0,0);
}

40%, 43% {
  transform: translate3d(0, -30px, 0);
}

70% {
  transform: translate3d(0, -15px, 0);
}

90% {
  transform: translate3d(0,-4px,0);
}
`
export const ButtonHoverAni = keyframes`
  0% {
    transform: translate3d(-50%, -50%, 0) scale3d(0, 0, 0);
  }
  35% {
    transform: translate3d(-50%, -50%, 0) scale3d(50, 50, 50);
  }
  100%  {
    transform: translate3d(-50%, -50%, 0) scale3d(0, 0, 0);
  }
`
const bubblePulseAni = keyframes`
 0% {
   transform: translate3d(-50%, -50%, 0) scale3d(0.95, 0.95, 0.95);
   box-shadow: 0 0 0 0 rgba(238,238,238,.35);
 }
 70% {
   transform: translate3d(-50%, -50%, 0) scale3d(1.15, 1.15, 1.15);
   box-shadow: 0 0 0 16px rgba(255,197,21,0);
 }
 100% {
   transform: translate3d(-50%, -50%, 0) scale3d(0.95, 0.95, 0.95);
   box-shadow: 0 0 0 0 rgba(255,197,21,0);
 }
`
const giftBoxAni = keyframes`
  0% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(10deg);
  }
  25% {
    transform: rotate(-12deg);
  }
  37% {
    transform: rotate(6deg);
  }
  50% {
    transform: rotate(-4deg);
  }
  70%, 100% {
    transform: rotate(0deg);
  }
`
const bigGiftBoxAni = keyframes`
  0% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(3deg);
  }
  25% {
    transform: rotate(-3deg);
  }
  37% {
    transform: rotate(2deg);
  }
  50% {
    transform: rotate(-1deg);
  }
  70%, 100% {
    transform: rotate(0deg);
  }
`
const bigBubbleAni = keyframes`
  0% {
    transform: translate3d(-50%, 0, 0) scale3d(1, 1, 1);
  }
  12% {
    transform: translate3d(-50%, 0, 0) scale3d(1.05, 1.05, 1.05);
  }
  25% {
    transform: translate3d(-50%, 0, 0) scale3d(.99, .99, .99);
  }
  30% {
    transform: translate3d(-50%, 0, 0) scale3d(1.03, 1.03, 1.03);
  }
  50%, 100% {
    transform: translate3d(-50%, 0, 0) scale3d(1, 1, 1);
  }
`
// /////////////////////////////////////////// button /////////////////////////////////////////////
// 공통 버튼 스타일
export const ButtonStyles = (props: ThemeProps) =>
  css`
    z-index: 1;
    position: relative;
    width: inherit;
    height: auto;
    padding: 0;
    line-height: 1.2rem;
    text-align: center;
    vertical-align: middle;
    border: none;
    box-shadow: none;
    color: ${props.theme.color.themeTxt};
    font-size: ${props.theme.font.medium};
  `
/* 기본 버튼 */
export const Button = styled.button`
  ${ButtonStyles};
  width: ${props => (props.circle ? '28px' : 'inherit')};
  height: ${props => (props.circle ? '28px' : 'inherit')};
  background: ${props => {
    if (props.primary) return props.theme.color.primaryBg
    if (props.secondary) return props.theme.color.secondaryBg
    if (props.navy) return props.theme.color.modalBlue
    if (props.sub) return props.theme.color.subBg
    if (props.blue) return props.theme.color.matchTit1
    if (props.gray) return props.theme.color.subColor
    if (props.TP) return props.theme.color.TP
    return props.theme.color.btn
  }};
  border-radius: ${props => {
    if (props.noRadius) return '0'
    if (props.circle) return '50%'
    return '50px'
  }};
  box-shadow: ${props => (props.float ? '0 2px 10px rgba(0,0,0,.5)' : 'none')};
  &.bottom-btn {
    height: 4rem;
    line-height: 4rem;
    & > svg {
      position:relative;
      top: 3px;
      width: 15px;
      height: 15px;
      margin-right: 4px;
      path {
        fill: #CEFF00;
      }
    }
    &.disabled {
      & > svg {
        path {
          fill: ${props => props.theme.color.gray};
        }
      }
      // 베팅내역 삭제모드 - 삭제 버튼
      &.delete {
        background: ${props => props.theme.color.disableBg};
        color: rgba(238, 238, 238, .3);
        svg {
          opacity: .3;
          path {
            fill: ${props => props.theme.color.underover};
          }
        }
      }
    }
  }
/* 빈화면 '베팅하기'버튼 */
  &.empty-btn-bet {
    top: 20px;
    width: 200px;
    height: 28px;
  }
  /* 핸디캡/언더오버 기준점 모달 버튼 */
  &.match-modal-btn {
    position:absolute;
    top:0;
    left:-4px;
    width:calc(100% + 8px);
    height: ${MatchBtnH};
    padding: 0 4px;
    line-height: 3.4rem;
    background:${props => props.theme.color.TP};
    text-align: left;
    svg {
      position:absolute;
      top: 9px;
      right: 4%;
      width: 16px;
      path#arrow {
        fill: ${props => props.theme.color.gray};
      }
      path#bg {
        fill: ${props => props.theme.color.subBg};
      }
    }
  }
    /* 이벤트 팝업 버튼 */
  &.event-popup-btn-cls {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    line-height: 1.8rem;
    background: transparent;
    margin-left: auto;
    /* 닫기 버튼 아이콘 */
    .cls-txt {
      margin-right: 4px;
    }
    .cls-ico {
      position: relative;
      top: -1px;
      display: inline-block;
      text-indent: 100%;
      white-space: nowrap;
      overflow:hidden;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid  ${props => props.theme.color.themeTxt};
      transform:rotate(45deg);
      &::before {
        content: '';
        position: absolute;
        top:50%;
        left: 50%;
        display: block;
        width: 1px;
        height: 8px;
        border-right: 1px solid ${props => props.theme.color.themeTxt};
        transform: translate(-50%,-50%);
      }
      &::after {
        content: '';
        position: absolute;
        top:50%;
        left: 50%;
        display: block;
        width: 8px;
        height: 1px;
        border-top: 1px solid ${props => props.theme.color.themeTxt};
        transform: translate(-50%,-50%);
      }
    }
  }
  /* 가이드 버튼 */
  &.guide-btn {
    z-index: 0;
    position: relative;
    top: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    border-radius: 0;
    svg {
      width: 14px;
      margin-right: 4px;
      transform: translateY(-4%);
    }
  }
  /* tooltip btn  */
  &.tooltip-btn {
    width: 35px;
    background: none;
    svg {
      position: relative;
      width: 14px;
    }
    &.bet-slip {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      width: 52px;
      height: 100%;
      margin-right: -30px;
      border-radius: 0;
      &.min, &.sider {
        margin-right: -18px;
      }
    }
  }
  // 베팅 취소 버튼
  &.betting-cancel-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 24px;
    margin-left: 4px;
    line-height: 2.4rem;
    .betting-cancel-txt {
      font-size: ${props => props.theme.font.small};
    }
    svg {
      position: relative;
      top: -1px;
      width: 14px;
      height: auto;
      margin-left: 3px;
    }
    &.disabled {
      width: 70px;
      background: none;
      .betting-cancel-txt {
        color: ${props => props.theme.color.gray};
      }
    }
  }
  &.change-match-btn {
    position: absolute;
    top: 50%;
    left: 14px;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 24px;
    border-radius: 6px;
    background: #2C3340;
    svg {
      width: 18px;
      height: auto;
      path.arrow {
        fill: ${props => props.theme.color.yellow};
      }
    }
  }
  // full modal - floating close button
  &.full-modal-cls-btn {
    position: fixed;
    right: 18px;
    bottom: ${FloatingBottom2};
    width: 45px;
    height: auto;
    min-height: 45px;
    padding-bottom: ${SafeAreaEnvPadding};
    padding-bottom: ${SafeAreaConstantPadding};
    box-shadow: none;
    .btn-bg {
      position: relative;
      width: inherit;
      height: 45px;
      backdrop-filter: blur(20px);
      border-radius: 50%;
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        width: inherit;
        height: inherit;
        transform: translate(-50%, -50%);
        background: ${props => props.theme.color.btn};
        border-radius: 50%;
        opacity: 0.3;
      }
    }
    .cls-ico {
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 17px;
      height: 17px;
      &::before, &::after {
        content: '';
        display: block;
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        border-radius: 10px;
        background: ${props=>props.theme.color.modalBg};
      }
      &::before {
        width: 100%;
        height: 2px;
      }
      &::after {
        width: 2px;
        height: 100%;
      }
    }
    &.sider {
      bottom: 18px;
      .close-txt {
        position: absolute;
        line-height: 9999;
      }
      .btn-bg {
        backdrop-filter: none;
        &::before {
          background: ${props => props.theme.color.modalBg};
          opacity: 1;
        }
      }
      .cls-ico {
        &::before, &::after {
          background: ${props=>props.theme.color.disableTxt};
        }
      }
    }
  }
  &.btn-color {
    color: ${props=>props.theme.color.btn};
    svg path {
      fill: ${props=>props.theme.color.btn};
    }
  }
`

export const PageBottomBtnStyle = (theme:Theme) => css`
  width: 100%;
  height: 40px;
  min-height: 40px;
  border-radius: 9px;
  font-size: ${theme.font.large};
  &.active {
    background: ${theme.color.secondaryBg};
  }
  &.sticky {
    position:sticky;
    bottom: 14px;
  }
`
export const TestStyle = (theme:Theme) => css`
  img {
    width: 100%;
    height: auto;
  }
`
export const TermsWrapStyle = (theme: Theme) => css`
  img {
    width: 100%;
    height: auto;
  }
  .bottom-btn-wrap {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: auto;
    padding: 18px 14px 0;
    padding-bottom: ${SafeAreaEnvPadding};
    padding-bottom: ${SafeAreaConstantPadding};
    background: linear-gradient(to top, rgba(238, 238, 238, 1) 50%,rgba(238, 238, 238, 0));
    button {
      width: 100%;
      height: 45px;
      margin-bottom: 14px;
      border-radius: 6px;
      font-size: ${theme.font.large};
      color: ${theme.color.themeTxt};
      background: ${theme.color.subBg};
      border: none;
    }
  }
  // 마케팅, 광고 정보 수신 동의 컨텐츠의 높이값이 짧아 별도의 스타일 지정
  &.sns {
    height: 100%;
    background: ${theme.color.themeTxt};
  }
`
// 뒤로가기 버튼 (mobile - 상세경기 페이지)
export const BackBtn = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 100%;
  line-height: 1.2rem;
  text-align: center;
  cursor: pointer;
  svg {
    position: relative;
    width: auto;
    height: 8px;
    transform: rotate(90deg);
    path {
      fill: ${props => props.theme.color.primary};
    }
  }
`
export const GiftBtnHoverAni = keyframes`
  0%, 100% {
    transform:translate(-50%, -75%) scale(.85);
  }
  35% {
    transform:translate(-50%, -75%) scale(1.12);
  }
`
export const GiftBtnStlye = (theme: Theme) => css`
  position: absolute;
  top: 5px;
  right: 15px;
  width: auto;
  min-width: 40px;
  height: 36px;
  background:none;
  /* 선물상자 뒷배경(glow) */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    box-shadow: 0 0 15px #F14331;
    animation: ${GiftBtnHoverAni} 1.8s infinite;
  }
  .gift-txt {
    position:relative;
    top: 11px;
    font-size: ${theme.font.small};
  }
  .gift-ico {
    position: absolute;
    top:50%;
    left: 50%;
    transform:translate(-50%,-80%);
    width: 21px;
    height: auto;
  }
`
export const FilterBtnStyle = (theme: Theme)  => css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 30px;
  padding: 0 14px;
  line-height: 1.2rem;
  border-radius: 50%;
  background: none;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: inherit;
    background: linear-gradient(to left, ${theme.color.mainBg}, transparent);
  }
  svg {
    width: 18px;
    height: auto;
    color: ${theme.color.darkTxt};
  }
  // &.go-match-result-btn {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   right: -30px;
  //   width: 96px;
  //   height: 34px;
  //   padding: 1px 8px 0;
  //   color: ${theme.color.modalTxt};
  //   border-radius: 50px;
  //   background: ${theme.color.themeTxt};
  //   svg {
  //     width: 16px;
  //     margin-right: 2px;
  //     transform: translateY(-1px);
  //   }
  //   .arrow {
  //     position: relative;
  //     width: 5px;
  //     height: 5px;
  //     transform: rotate(-45deg) scale(1.2);
  //     margin-left: 4px;
  //     &::before, &::after {
  //       content:'';
  //       display: block;
  //       position: absolute;
  //       bottom: 0;
  //       right: 0;
  //       background: ${theme.color.mainBg};
  //       border-radius: 5px;
  //     }
  //     &::before {
  //       width: 100%;
  //       height: 1px;
  //     }
  //     &::after {
  //       width: 1px;
  //       height: 100%;
  //     }
  //   }
  // }
`
// 닫기 버튼

export const CloseBtnStyle = css `
  z-index: 99;
  position: absolute;
  top: 0;
  right: -25px;
  width: 40px;
  height: 40px;
  overflow: hidden;
  background: transparent;
  border: none;
  box-shadow: none;
  .bg {
    display: inline-block;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background: #acacac;
  }
  &::before {
    position: absolute;
    top: 50%;
    left: 14px;
    display: block;
    width: 12px;
    height: 1px;
    background: #eee;
    border: none;
    border-radius: 0;
    transform: rotate(45deg) scale(1.5);
    opacity: 1;
    animation: none;
    content: '';
  }
  &::after {
    position: absolute;
    top: 50%;
    left: 14px;
    display: block;
    width: 12px;
    height: 1px;
    background: #eee;
    transform: rotate(-45deg) scale(1.5);
    opacity: 1;
    content: '';
  }
`
export const CloseBtn = (theme: Theme) =>
  css`
    ${CloseBtnStyle};
    /* 풀 팝업 닫기 버튼 */
    &.close-btn {
      top: 3px;
      right: 4px;
      padding: 0;
      &.position-top {
        top: -40px;
      }
    }
    .close-txt {
      position: absolute;
      line-height: 9999;
    }
    /* 채팅 팝업 닫기 버튼 */
    &.chat {
      &.close-btn {
        top: -2px;
      }
      &::before,
      &::after {
        background: ${theme.color.modalSubTxt};
      }
    }
    /* 서랍 메뉴 닫기 버튼 */
    &.sider-close-btn {
      top: initial;
      bottom: 16px;
      right: 18px;
      width: 45px;
      height: 45px;
      background: ${theme.color.modalBg};
      &::before,
      &::after {
        left: 15px;
        background: ${theme.color.disableTxt};
      }
    }
    &.login-close-btn {
      top: 0;
      right: 0;
      width: 45px;
      height: 45px;
      &::before,
      &::after {
        left: 15px;
        background: ${theme.color.disableTxt};
      }
    }
    /* pc버전 modal 닫기 버튼 */
    &.modal-circle-close-btn {
      position: absolute;
      top: -70px;
      left: 50%;
      width: 50px;
      height: 50px;
      background: none;
      transform: translate(-50%,0);
      border: 1px solid ${theme.color.themeTxt};
      &::before,&::after  {
        width: 25px;
        top: calc(50% - (1px));
        left: 12px;
      }
    }
    &.pc-close-circle-btn {
      position: absolute;
      top: -70px;
      left: 50%;
      width: 50px;
      height: 50px;
      background: none;
      transform: translate(-50%,0);
      border: 1px solid ${theme.color.themeTxt};
      &::before,&::after  {
        width: 25px;
        top: calc(50% - (1px));
        left: 12px;
      }
    }
    &.modal-bottom-btn {
      display: block;
      top: initial;
      bottom: -90px;
      background: rgba(28, 32, 43, .8);
      &::before,
      &::after {
        height: 1px;
      }
    }
    &.event-modal {
      top: 0;
      left: initial;
      right: 40px;
      transform: initial;
      display: block;
      width: 32px;
      height: 32px;
      &::before, &::after {
        width: 16px;
        left: 7px;
      }
    }
  `
export const CheckboxBtn = (theme: Theme) => css`
  position: absolute;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0, 0, 0, 0);
  * {
    transition: all .3s;
  }
  & + label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    padding: 0 8px 0 14px;
    background: ${theme.color.modalSubBg};
    border-radius: 50px;

    .check-ico {
      position: relative;
      top: -2px;
      width: 7px;
      height: 12px;
      transform: rotate(45deg);
      &::before, &::after {
        content: '';
        display: block;
        position: absolute;
        background: ${theme.color.modalBg};
        border-radius: 50px;
      }
      &::before {
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
      }
      &::after {
        bottom: 0;
        right: 0;
        width: 3px;
        height: 100%;
      }
    }
  }

  &:checked + label {
    background: ${theme.color.primary};
    .check-ico {
      &::before, &::after {
        background: ${theme.color.themeTxt};
      }
    }
  }
`
export const CheckBoxStyle = (props: ThemeProps) => css`
  /* check box */
  .ant-checkbox {
    width: 24px;
    height: 24px;
    input {
      width: inherit;
      height: inherit;
    }
    .ant-checkbox-inner {
      width: inherit;
      height: inherit;
      background: none;
      border: 4px solid ${props.theme.color.disableTxt};
      border-radius: 50%;
    }
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${props.theme.color.disableTxt};
  }
  .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
    background: ${props.theme.color.primary} !important;
    &::after {
      width: 8px;
      height: 14px;
      left: 28%;
      border: 2px solid ${props.theme.color.themeTxt};
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(1) translate(-80%, -40%);
    }
  }
  .ant-checkbox-checked::after {
    border-radius: 50%;
  }
`
export const CheckBoxMonoToneStyle = (props: ThemeProps) => css`
  /* check box */
  .ant-checkbox {
    width: 20px;
    height: 20px;
    input {
      width: inherit;
      height: inherit;
    }
    .ant-checkbox-inner {
      width: inherit;
      height: inherit;
      background: none;
      border: 1.5px solid ${props.theme.color.modalDarkBg};
      border-radius: 50%;
    }
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${props.theme.color.disableTxt};
  }
  .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
    background: ${props.theme.color.accordion2} !important;
    border: none;
    &::after {
      width: 6px;
      height: 11px;
      left: 39%;
      border-radius: 1px;
      border: 2px solid ${props.theme.color.themeTxt};
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(1) translate(-80%, -40%);
    }
  }
  .ant-checkbox-checked::after {
    border: none;
    border-radius: 50%;
  }
`
export const CheckRadioBoxStyle = (props: ThemeProps) => css`
  .ant-radio {
    .ant-radio-inner {
      background: none;
      border-color:  ${props.theme.color.modalDarkBg};
      &::after {
        left: 45%;
        transform: rotate(45deg) scale(1) translate(0, 17%);
        width: 4px;
        height: 7px;
        border: 1px solid ${props.theme.color.themeTxt};
        border-top: 0;
        border-left: 0;
        border-radius: 0;
        background: none;
      }
    }
    &.ant-radio-checked {
      &::after {
        border-color: ${props.theme.color.accordion2};
      }
      .ant-radio-inner {
        border: none;
        background: ${props.theme.color.accordion2};
      }
    }
    & + span {
      font-size: ${props.theme.font.large};
      font-weight: ${props.theme.fontW.medium};
      color: ${props.theme.color.modalTxt};
    }
    .ant-radio-input:focus + .ant-radio-inner {
      box-shadow: none;
    }
  }
`
const SwitchBtnCustomStyle = props => css`
  & + .on-off-wrap {
    width: ${props.width}px;
    height: ${props.height}px;
    line-height: ${props.height}px;
    margin-top: ${props.marginTop}px;
    margin-bottom: ${props.marginBottom}px;
    margin-left: ${props.marginLeft}px;
    margin-right: ${props.marginRight}px;
    &::after {
      left: 2px;
      width: calc(${props.height}px - 4px);
      height: calc(${props.height}px - 4px);
    }
    .on {
      margin-left: calc(${props.width}px / 6);
    }
    .off {
      margin-right: calc(${props.width}px / 6);
    }
    &:checked + .on-off-wrap {
      left: calc(100% - (${props.height}px - 4px) - 1px);
    }
  }
`
export const SwitchBtn = styled.input`
  position: absolute;
  left: 0;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0, 0, 0, 0);
  & + .on-off-wrap {
    position: relative;
    display: inline-block;
    width: 70px;
    height: 28px;
    line-height: 28px;
    border-radius: 50px;
    background:  ${props => props.theme.color.btn};
    transition: all .3s;
    &::after {
      content:'';
      position: absolute;
      top: 50%;
      left: 2px;
      display: block;
      width: 23px;
      height: 23px;
      border-radius: 50%;
      background:  ${props => props.theme.color.themeTxt};
      transform: translate(0,-50%);
      transition: all .3s;
    }
    .on, .off {
      position: relative;
      font-size: ${props => props.theme.font.large};
    }
    .on {
      display: none;
      float: left;
      margin-left: 12px;
      background: linear-gradient(to bottom, rgb(255,255,255), rgb(193,240,245));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .off {
      display: block;
      float: right;
      margin-right: 12px;
      background: linear-gradient(to bottom, rgb(255,255,255), rgb(202,209,217));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  &:checked + .on-off-wrap  {
    background:  ${props => props.theme.color.primaryBg};
    .on {
      display: block;
    }
    .off {
      display: none;
    }
    &::after {
      left: calc(100% - 21px);
    }
  }
  ${SwitchBtnCustomStyle};
`

// switch button (설정 / 텔레그램)
export const SwitchBtnWrap = styled.div`
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 4px;
  background: ${props => props.theme.color.modalDarkBg};
  .switch-btn-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(50% - 2px);
    height: 94px;
    margin-bottom: 4px;
    padding: 16px;
    text-align:center;
    border-radius: 3px;
    background: ${props => props.theme.color.modalBg};
     &:nth-last-of-type(1), &:nth-last-of-type(2) {
      margin-bottom: 0;
     }
    &--txt {
      color: ${props => props.theme.color.modalTxt};
    }

    &--btn {
      position: absolute;
      left: 0;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      border: 0;
      clip: rect(0, 0, 0, 0);
      & + .on-off-wrap {
        position:relative;
        display: block;
        width: 70px;
        height: 28px;
        line-height: 3rem;
        margin-top: 10px;
        border-radius: 50px;
        background:  ${props => props.theme.color.btn};
        transition: all .3s;
        &::after {
          content:'';
          position: absolute;
          top:50%;
          left:3px;
          display: block;
          width:23px;
          height:23px;
          border-radius: 50%;
          background:  ${props => props.theme.color.themeTxt};
          transform: translate(0,-50%);
          transition: all .3s;
        }
        .on, .off {
          position: relative;
          font-size:  ${props => props.theme.font.large};
        }
        .on {
          display: none;
          float: left;
          margin-left: 16px;
          background: linear-gradient(to bottom, rgb(255,255,255), rgb(193,240,245));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .off {
          display: block;
          float: right;
          margin-right: 12px;
          background: linear-gradient(to bottom, rgb(255,255,255), rgb(202,209,217));
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      &:checked + .on-off-wrap  {
        background:  ${props => props.theme.color.primaryBg};
        .on {
          display: block;
        }
        .off {
          display: none;
        }
        &::after {
          transform: translate(180%, -50%);
        }
      }
    }
  }

  &.betslip-switch {
    display: inline-flex;
    width: auto;
    background: none;
  }
`
// ///////////////////////////////// Modal button /////////////////////////////////
// 메세지/쪽지 하단 버튼
export const BottomBtnStyle = css`
  position: relative;
  left: -14px;
  width: calc(100% + 28px);
  height: 36px;
  border-radius: 0;
`
export const ButtonWrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  &.modal {
    left: -14px;
    width: 100vw;
  }
  /* ButtonWrap 바로 상단에 텍스트가 없는 경우 */
  &.custom-dialog-btn-wrap {
    padding-top: 16px;
    background-color: ${props => props.theme.color.modalBg};
    border-radius: 0 0 20px 20px;
  }
  /* custom-dialog에서 쓰여진 경우(guide) */
  &.custom-dialog-wrap {
    padding: 0 16px;
  }
  &.full-modal {
    z-index: 1;
    position:fixed;
    bottom: 0;
    left: 0;
    .bottom-btn {
      background: ${props => props.theme.color.primaryBg};
    }
  }
  &.middle-modal-btn-wrap {
    width: 256px;
    margin: 0 auto;
    padding: 16px;
    .two-btn {
       flex: 1;
       height: 30px;
       &.cancel {
        margin-right: 16px;
       }
    }
  }
  // 모달이 아닌 페이지에서 뜨는 ButtonWrap - Nav로 인해 위로 이동
  &.page-btn-wrap {
    bottom: ${NavH};
    padding-bottom: calc(env(safe-area-inset-bottom) - 18px);
    padding-bottom: calc(constant(safe-area-inset-button) - 18px);
  }
`
export const BottomBtnWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 14px 0;
  .bottom-btn {
    flex: 1;
    border-radius: 3px;
    &.negative-btn {
      margin-right: 14px;
    }
  }
`
export const PopupBtnStyle = (theme: Theme) => css`
  position: relative;
  &:not(.message) {
    margin-bottom: 16px !important;
  }
  &.one-button {
    width: 50%;
    min-width: 165px;
    height: 30px;
    line-height: 3rem;
    margin: 0 auto;
    border-radius: 20px;
    background-color: ${theme.color.secondaryBg};
    /* 꽉찬 버튼 */
    &.bottom-btn {
      width: 100vw;
      height: 40px;
      margin-top: 19px;
      margin-bottom: 0 !important;
      line-height: 4rem;
      left: 0;
      border-radius: 0;
      &.bet-success {
        margin-top: 0;
      }
    }
  }
  /* 라운드 버튼 */
  &.two-button {
    width: calc(100% - 14px);
    height: 32px;
    line-height: 3.2rem;
    background-color: ${theme.color.secondaryBg};
    &.cancel {
      width: 100%;
      background-color: ${theme.color.btn};
    }
    &.primary {
      background-color: ${theme.color.primaryBg};
    }
    /* 꽉찬 버튼 */
    &.bottom-btn {
      left: 0;
      width: 60%;
      //height: 40px;
      line-height: 4rem;
      height: inherit;
      margin-top: 0;
      margin-bottom: 0 !important;
      border-radius: 0;
      &.cancel {
        width: 40%;
      }
      &.modal {
        background-color: ${theme.color.primaryBg};
        &.cancel {
          color: ${theme.color.contentsBg};
          background-color: ${theme.color.themeTxt};
        }
      }
    }
    &.dialog {
      flex: 5;
      margin-left: 13px;
      &.cancel {
        flex: 3;
        max-width: 135px;
        margin-left: 0;
      }
    }
    &.message {
      margin-top: 8px;
    }
  }
  svg {
    position: relative;
    top: 3px;
    width: 15px;
    height: 15px;
    margin-right: 4px;
  }
  &:not(.trash) {
    svg path {
      fill: ${theme.color.underover};
    }
  }
  &.money {
    svg {
      width: 13px;
      margin: 0 1px 0 2px;
      path {
        fill: ${theme.color.yellow};
      }
    }
  }
`
// 새로운 하단 버튼
export const FooterBtnStyle = (theme:Theme) => css`
  width: 100%;
  height: 45px;
  border-radius: 6px;
  &.one-btn {
    &.dark {
      background: ${theme.color.accordion2};
    }
  }
`
// 모달 하단 버튼 영역 - 여백 O (아이템샵/스킨 변경/픽 공유)
export const ModalFooterWrap = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
`
// 수량 +/- 버튼
export const CountBtnWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  height: 36px;
  line-height: 3.6rem;
  border-radius: 50px;
  overflow: hidden;
  .btn {
    flex:1;
    background: ${props => props.theme.color.modalSubBg};
    border-radius: 0;
    &.minus {
      &::before {
        content:'';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 12px;
        height: 2px;
        background: ${props => props.theme.color.btn};
      }
    }
    &.plus {
      &::before, &::after {
        content:'';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 12px;
        height: 2px;
        background: ${props => props.theme.color.btn};
      }
      &::after {
        transform: translate(-50%,-50%) rotate(90deg);
      }
    }
  }
  .number-format {
    flex: 2;
    min-width: 0;
    text-align: center;
    color: ${props => props.theme.color.modalTxt};
    background: ${props => props.theme.color.modalSubBg};
    border: none;
    border-radius: 0;
  }
`
// 오늘 하루 보지않기 버튼 (선물상자 / 초기 팝업)
export const EventFooter = (theme: Theme) => css`
  display: flex;
  flex-wrap: nowrap;
  justify-content:space-between;
  width: 100%;
  #check {
    position: absolute;
    left: 0;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    border: 0;
    clip: rect(0, 0, 0, 0);
    & + .check-label {
      padding: 5px 10px;
      .check-label-ico {
        opacity: 0;
        display: inline-block;
        position: relative;
        top: 3px;
        text-indent: 100%;
        white-space: nowrap;
        overflow:hidden;
        width: 15px;
        height: 15px;
        transform: rotate(45deg);
        &::before {
          content:'';
          opacity: 0;
          position: absolute;
          top: 12px;
          left: 0;
          display: block;
          width: 7px;
          height: 2px;
          background:${theme.color.themeTxt};
          border-radius: 10px;
        }
        &::after {
          content:'';
          opacity: 0;
          position: absolute;
          top: 50%;
          left: 5px;
          display: block;
          width: 2px;
          height: 12px;
          background:${theme.color.themeTxt};
          transform: translate(0,-50%);
          border-radius: 10px;
        }
      }
    }
    &:checked + .check-label .check-label-ico {
      opacity: 1;
      &::before,
      &::after {
        opacity: 1;
      }
    }
  }
  &.match-up-modal {
    height: 50px;
    align-items: center;
    #check {
      &+ .check-label {
        padding:  16px 24px;
        .check-label-ico {
          display: none;
        }
        .check-label-txt {
          color: ${theme.color.modalDarkBg};
          font-size: ${theme.font.medium};
          font-weight: ${theme.fontW.medium};
        }
      }
    } 
    .cls-txt{
      color: ${theme.color.mainBg};
      font-size: ${theme.font.large};
      font-weight: ${theme.fontW.bold};
    }
  }
  // 박스타입의 버튼 클래스 (파트너십 체결 팝업)
  &.box-type-bottom {
    height: 54px;
    background: ${theme.color.white};
    border-radius: 0 0 8px 8px;
    .check-label {
      display: flex;
      align-items: center;
      &-txt {
        color: ${theme.color.modalSubBg};
        font-size: ${theme.font.large};
        font-weight: ${theme.fontW.medium};
      }
    }
    .event-popup-btn-cls {
      .cls-txt {
        color: ${theme.color.modalTxt};
        font-size: ${theme.font.large};
        font-weight: ${theme.fontW.bold};
      }
    }
  }
`
export const UserItemRootWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: auto;
  max-height: calc(100% - 40px);
  overflow-y: scroll;
  padding: 4px;
  text-align: left;
  &.pc {
    max-height: calc(100% - 25px);
  }
  .check-box {
    z-index: 1;
    position: relative;
    width: 50%;
    height: 150px;
    &::before {
      content: '';
      z-index: 1;
      position: absolute;
      top: 9px;
      left: 9px;
      display: block;
      width: calc(100% - 18px);
      height: 105px;
      background: ${props => props.theme.color.subBg};
      border-radius: 6px;
    }
    &::after {
      content: '';
      z-index: -1;
      position: absolute;
      top: 0;
      left: 3px;
      display: block;
      width:calc(100% - 6px);
      height: 144px;
      background: ${props => props.theme.color.btn};
      border-radius: 12px;
    }
    /* check box */
    &.ant-checkbox-wrapper {
      margin-left: 0 !important;
      .num-input-group {
        display: none;
      }
      &-checked {
        .num-input-group {
          display: flex;
        }
      }
    }
    ${CheckBoxStyle};
    .ant-checkbox {
      z-index: 2;
      top: 12px;
      left: 12px;
      width: 20px;
      height: 20px;
      .ant-checkbox-inner {
        border: none;
      }
    }
    .ant-checkbox.ant-checkbox-checked {
      .ant-checkbox-inner {
        &::after {
          width: 7px;
          height: 12px;
          left: 25%;
          transform: rotate(45deg) scale(1) translate(-50%, -50%);
        }
      }
    }
  }
`

export const SkinWrap = styled.div`
  z-index: 1;
  position: relative;
  top: -10px;
  height: 135px;
`

export const SkinImg = styled.img`
  z-index: 1;
  position: relative;
  top: 13px;
  height: 90px;
  display: block;
  margin: 0 auto;
`

export const SkinCount = styled.p`
  position: absolute;
  top: 4px;
  /* top: 82px; */
  right: 14px;
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.color.gray};
  .point {
    font-size: ${props => props.theme.font.small};
  }
`

export const SkinTitle = styled.span`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%,-50%);
`
// drop down button

const gooSizeAni = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(.7);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
`
const rotateAni = keyframes`
  100% {
    transform: rotate(360deg);
  }
`
const bgAni = keyframes`
  0% {
    width: 20px;
    height: 80px;
    transform: rotate(40deg) translate(-40px, -100%);
    background: ${AniPointColor};
  }
  40% {
    width: 20px;
  }
  90% {
    background: ${AniPointColor};
  }
  100% {
    width: 10px;
    height: 80px;
    transform: rotate(40deg) translate(55px, -70%);
    background: ${AniPointColorHide};
  }
`
const QuickMenuCenterBtnTop = '5px'
const QuickMenuCenterBtnLeft = '5px'
const QuickMenuCloseTime = '0.3s'
export const QuickMenuBtn = styled.div`
  z-index: 4;
  position: relative;
  right: 20%;
  width: 40px;
  height: 40px;
  transition: z-index ease-out ${QuickMenuCloseTime}; /* 닫을 때, header와 tab 뒤에 나타나는 현상 해결*/
  .modal-bg {
    width: 0;
    height: 0;
    opacity: 0;
    // 닫힐 때 속도
    transition: opacity .35s;
  }
  .quick-menu-list {
     &--item {
      position:absolute;
      top: 9px;
      left: 9px;
      width: 20px;
      height: 20px;
      line-height: initial;
      transition: all cubic-bezier(0.935, 0.000, 0.340, 1);
      transition-duration: ${QuickMenuCloseTime};
      .menu-item-ani {
        display: none;
        ${CommonPeekAni};
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 50%;
        &--bg {
           position: absolute;
           top: 50%;
           left: -40px;
           animation: none;
         }
      }
      // 클럽 포탈
      &.menu2 {
        .menu-item-ani {
          display: block;
        }
        svg, .quick-menu-list--item--btn--txt {
          position: relative;
        }
      }
      &.menu6 {
        position: fixed;
        opacity: 0;
        top: initial;
        right: initial;
        bottom: 50px;
        left: 50%;
        transform: translate(-50%,0);
        width: 80px;
        height: 80px;
        transition-duration: .1s;
        .gift-ico {
          width: 65px;
          height: auto;
          margin-top: 8px;
          & + span {
            margin-top: -8px;
          }
        }
        // 활성화 시 뒷배경 애니
        .pulse-ani {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 93px;
          height: 93px;
          border-radius: 50%;
          &.ani-2 {
            width: 87px;
            height: 87px;
          }
          &.ani-3 {
            width: 83px;
            height: 83px;
          }
        }
      }
      &--btn {
        display: none;
        transition: opacity .25s ease-in;
        opacity: 0;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        flex-wrap: wrap;
        line-height: 2rem;
        background: ${props => props.theme.color.modalSubBg2};
        overflow: hidden;
        .scash-ico {
          width: 100%;
          height: auto;
          & + span {
            position: absolute;
            bottom: 3px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        svg {
          transition: opacity .25s;
          opacity: 0;
          width: 100%;
          max-width: 20px;
          max-height: 20px;
          margin-top: 4px;
          path {
            fill: ${props => props.theme.color.modalTxt};
          }
        }
        &--txt {
          transition: opacity .25s;
          opacity: 0;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.small};
        }
      }
    }
  }
  .quick-menu-circle {
    z-index: 1;
    position: relative;
    opacity: 1;
    top: ${QuickMenuCenterBtnTop};
    left: ${QuickMenuCenterBtnLeft};
    width: 26px;
    height: 26px;
    // 닫을 때 속도
    transition: all .15s cubic-bezier(.41,-0.24,.33,1.4);
    .green-btn {
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: linear-gradient(#3FBC4C, #108F99);
      border: 1px solid ${props => props.theme.color.modalBg};
      &--center {
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: ${props => props.theme.color.themeTxt};
        animation: ${gooSizeAni} 1s infinite alternate-reverse ease;
      }
    }
  }
  // 선물상자 수령 가능 시
  .gift-box-alert {
    position: absolute;
    top: 0;
    right: -27px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    &--bubble {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 22px;
      height: 22px;
      background: #eee;
      border-radius: 50%;
    }
    &--bubble-tail {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-260%,-35%) rotate(-1deg);
      width: 6px;
    }
    &--gift-box {
      position: relative;
      width: 15px;
      height: auto;
      animation: ${giftBoxAni} 1.7s infinite ease-in;
      animation-delay: .1s;
    }
  }
  &.show {
    transition: z-index ease-out .1s; /* 닫을 때, header와 tab 뒤에 나타나는 현상 해결*/
    z-index: 102;
    .gift-box-alert {
      display:none;
    }
    .modal-bg {
      width: 100vw;
      height: 100vh;
      opacity: .7;
      transition: opacity .3s;
    }
    .quick-menu-list--item {
      width: 55px;
      height: 55px;
      transition: all cubic-bezier(.41,-0.24,.33,1.57);
      &--btn {
        display: flex;
        transition: opacity .2s cubic-bezier(.41,-0.24,.33,1.57);
        opacity: 1;
        svg {
          opacity: 1;
        }
        &--txt {
          opacity: 1;
        }
        .menu-item-ani {
          &--bg {
             animation: ${bgAni} 1.6s cubic-bezier(0.64, 0.16, 0.36, 0.83) infinite;
           }
        }
      }
      // 열릴 때 속도
      &.menu1 {
        transition-duration: .15s;
        top: calc(${QuickMenuCenterBtnTop} - 30px);
        left: calc(${QuickMenuCenterBtnLeft} - 150px);
      }
      &.menu2 {
        transition-duration:.2s;
        top: calc(${QuickMenuCenterBtnTop} + 40px);
        left: calc(${QuickMenuCenterBtnLeft} - 145px);
      }
      &.menu3 {
        transition-duration:.26s;
        top: calc(${QuickMenuCenterBtnTop} + 100px);
        left: calc(${QuickMenuCenterBtnLeft} - 95px);
      }
      &.menu4 {
        transition-duration: .33s;
        top: calc(${QuickMenuCenterBtnTop} + 125px);
        left: calc(${QuickMenuCenterBtnLeft} - 25px);
      }
      &.menu5 {
        transition-duration: .41s;
         top: calc(${QuickMenuCenterBtnTop} + 100px);
         left: calc(${QuickMenuCenterBtnLeft} + 45px);
        svg {
          margin-left: -2px;
        }
      }
      &.menu6 {
        opacity: 1;
        width: 96px;
        height: 96px;
        transition-property: width, height;
        transition-timing-function: cubic-bezier(0,1.48,1,1.93);
        transition-duration: .15s;
        // 선물상자 수령 가능 시
        &.active {
          animation: ${bigBubbleAni} 1.7s infinite;
          .gift-ico {
            animation: ${bigGiftBoxAni} 1.7s infinite ease-in;
            animation-delay: .05s;
          }
          .pulse-ani {
            display:block;
            animation: ${bubblePulseAni} 1.7s infinite ease-out;
            &.ani-2 {
              animation-delay: .2s;
            }
            &.ani-3 {
              animation-delay: .5s;
            }
          }
        }
      }
    }
    .quick-menu-circle {
      transition: all .2s cubic-bezier(.41,-0.24,.33,1.4);
      top: calc(${QuickMenuCenterBtnTop} + 5px);
      left: calc(${QuickMenuCenterBtnLeft} - 25px);
      width: 50px;
      height: 50px;
      animation: ${rotateAni} 3.5s linear infinite;
      .green-btn {
        border: none;
        &--center {
          animation: none;
        }
      }
    }
  }
  // 퀵 메뉴 열린 상태에서 스크롤 할 시
  &.no-transition {
    z-index: 4;
    transition: none;
    .quick-menu-circle {
      width: 26px;
      height: 26px;
      transition: none;
    }
    .quick-menu-list--item {
      background: none;
      transition: none;
      transition-duration: .1s;
    }
  }
`
export const QuickMenuCircle = styled.div``

// 상세 BET 라이브 - 비주얼라이제이션 토글 버튼
export const IframeToggleBtn =(theme:Theme) => css`
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  background: ${theme.color.modalSubBg2};
  .iframe-btn-arrow {
    position:relative;
    top: 4px;
    transform: rotate(-135deg);
    transition: all .3s;
    &::before, &::after {
      content:'';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 10px;
      background: ${theme.color.mainBg};
    }
    &::before {
      width: 2px;
      height: 10px;
    }
    &::after {
      width: 10px;
      height: 2px;
    }
    &.up {
      top: -4px;
      transform: rotate(45deg);
    }
  }
`
export const QuickSpotsMenuBtnStyle = (theme:Theme) => css`
  float: right;
  width: 50px;
  height: 19px;
  color: transparent;
  background: none;
  &::before {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 19px;
    height: 19px;
    background: ${theme.color.modalSubBg};
    border-radius: 50%;
    transition: all .3s;
  }
  .ant-popover.betting-history-quick-menu {
    width: 137px;
  }
  .spots {
    position: absolute;
    top: 50%;
    right: 16%;
    transform: translateY(-50%);
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: ${theme.color.mainBg};
    &::before, &::after {
      content:'';
      display: block;
      position:absolute;
      top: 0;
      left: 0;
      width: 3px;
      height: 3px;
      border-radius: 50%;
      background: ${theme.color.mainBg};
    }
    &::before {
      top: -5px;
    }
    &::after {
      top: 5px;
    }
  }

  &.ant-popover-open {
    &::before {
      display: block;
    }
  }
  &.club-message-filter-btn, &.message-setting-btn {
    width: 30px;
    height: 30px;
    .spots {
      right: initial;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &::before {
      right: initial;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    img {
      width: 30px;
      height: auto;
    }
  }
  &.club-message-filter-btn {
    margin-right: 6px;
    &::before {
      display: none;
    }
  }
`
export const TelegramGuideBtn = styled.div`
  z-index: 2;
  position: fixed;
  top: 49px;
  right: 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  height: auto;
  padding: 7px;
  background: rgba(23, 47, 75, .9);
  border-radius: 50px;
  img {
    width: 23px;
    height: auto;
  }
  .telegram-setting-txt {
    display: block;
    width: auto;
    height: auto;
    padding: 0 4px;
    font-size: ${props => props.theme.font.small};
    overflow: hidden;
    transition: all .3s;
    .point {
      font-size: ${props => props.theme.font.small};
    }
  }
  &.close {
    .telegram-setting-txt {
      width: 0;
      height: 0;
      padding: 0;
    }
  }
  &.pc-btn {
    top: 56px;
  }
`
export const CasinoBannerBtnStyle = css`
  border-radius: 8px;
  overflow: hidden;
  &.chat-banner, &.pc-chat-banner {
    position: absolute;
    top: 4px;
    right: 70px;
    width: auto;
    height: 34px;
    img {
      height: 34px;
    }
  }
  &.pc-chat-banner {
    top: initial;
    bottom: 14px;
    right: 17px;
    width: 79px;
  }
  &.sider-banner {
    position: absolute;
    bottom: 40px;
    left: 25px;
    width: 167px;
    height: 60px;
  }
  &.betting-history-banner {
    z-index: 2;
    position: absolute;
    top: 48px;
    right: 114px;
    width: auto;
    height: 38px;
    img {
      height: 38px;
    }
    &.pc-betting-history-banner {
      position: absolute;
      top: 56px;
      right: 114px;
      width: auto;
      height: 44px;
      img {
        height: 44px;
      }
    }
    &.no-telegram {
      right: 16px;
    }
  }
  &.matchup-banner {
    margin: 6px 12px 0;
    &.pc-matchup-banner {
      border-radius: 0;
    }
  }
`
export const XIcoBtn = (theme:Theme) => css`
  position: absolute;
  top: -50px;
  right: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 45px;
  height: 45px;
  .x-ico {
    position: relative;
    display:block;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    &::before, &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: ${theme.color.themeTxt};
    }
    &::before {
      width: 1px;
      height: 100%;
    }
    &::after {
      width: 100%;
      height: 1px;
    }
  }
  &.circle {
    top: -72px;
    .x-ico {
      border-radius: 50%;
      width: 30px;
      height: 30px;
      border: 1px solid ${theme.color.themeTxt};
      &::before {
        height: 50%;
      }
      &::after {
        width: 50%;
      }
    }
  }
`
export const BettingHistoryShareBtnStyle  = (theme:Theme) => css`
  float: right;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 22px;
  font-weight: ${theme.fontW.medium};
  .ant-checkbox {
    width: 18px;
    height: 18px;
    border: 2px solid ${theme.color.disableTxt};
    border-radius: 50%;
    transform: translateY(1px);
    & + span {
      padding-right: 3px;
      padding-left: 3px;
      color: ${theme.color.mainBg};
      font-weight: ${theme.fontW.medium};
    }
    .ant-checkbox-inner {
      position:absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: none;
    }

    // check
    &.ant-checkbox-checked {
      border-color: ${theme.color.select};
      &::after {
        display: none;
      }
      .ant-checkbox-inner {
        background: ${theme.color.select} !important;
        border: none;
        &::after {
          display: none;
        }
      }
    }
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
    border: none;
  }
`
// 월 이동
interface selectMonthProps {
  isWhite?: boolean
  isSingleBtn?: boolean
}
const SelectMonthWhiteStyle = (props:ThemeProps) => css`
  padding: 42px 18px 12px;
  background: ${props.theme.color.white};
  .prev-btn, .next-btn {
    &.disabled {
      opacity: .2;
    }
    .arrow {
      &::before, &::after {
        background: #707070;
      }
    }
  }
  .date {
    color: ${props.theme.color.modalDarkBg};
    .month {
      color: ${props.theme.color.modalTxt};
    }
  }
`
const SelectMonthSingBtnStyle = (props: ThemeProps) => css`
  justify-content: center;
  &.activity-score, &.activity-score-record {
    justify-content: space-between;
  }
  .prev-btn, .next-btn {
    &.disabled {
      visibility: hidden;
    }
  }
  .date {
    margin: 0 14px;
  }
`
export const SelectMonth = styled.div<selectMonthProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -1px;
  padding: 12px 18px;
  &.activity-score, &.activity-score-record {
    padding: 25px 18px 12px;
    &.disabled {
      opacity: 0;
    }
    &-record {
      background: #000000;
    }
    .date {
      .year {
        color: ${props => props.theme.color.modalDarkBg};
        margin-bottom: -4px;
      }
      .month {
        color: ${props => props.theme.color.modalTxt};
      }
      .score {
        color: ${props => props.theme.color.modalDarkBg};
      }
    }
    .btn-ico {
      color: #707070;
    }
  }
  &.activity-score-record {
    padding: 12px 18px 20px;
    background: ${props => props.theme.color.modalBg};
  }
  .prev-btn, .next-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    &.activity-reward-list {
      &.disabled {
        opacity: 0;
      }
    }
    &.disabled {
      opacity: .2;
    }
  }
  .date {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.color.darkTxt};
    font-weight: ${props => props.theme.font.medium};
    .month {
      line-height: 30px;
      font-size: ${props => props.theme.font.xxlarge};
      color: ${props => props.theme.color.themeTxt};
    }
  }
  ${props => {
    if (props.isWhite) return SelectMonthWhiteStyle
    return
  }};

  ${props => {
    if (props.isSingleBtn) return SelectMonthSingBtnStyle
    return
  }};
`
